import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero';
import Features from './Features';
// import Clients from './Clients';
// import Testimonials from './Testimonials';
import Developers from './Developers';
import Platform from './Platform';
import Enterprise from './Enterprise';
import Benchmark from './Benchmark';
import Domain from './Domain';
import Blog from './Blog';
import Community from './Community';
import FAQ from './FAQ';
import CTA from './CTA';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Agent Memory System | MemU - Agentic Memory for AI</title>
        <link rel="canonical" href="https://memu.pro/" />
        <meta name="description" content="Agent memory platform for LLM applications. Autonomous memory management with higher accuracy, faster retrieval, and lower cost." />
        <meta name="keywords" content="agent memory, agentic memory, AI memory system, memory management, LLM memory, autonomous agents, AI agents, memory layer, intelligent memory, contextual memory, open source" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Agent Memory System | MemU - Agentic Memory for AI" />
        <meta property="og:description" content="Agent memory platform for LLM applications. Autonomous memory management with higher accuracy, faster retrieval, and lower cost." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://memu.pro/" />
        <meta property="og:image" content="https://d192tm8h0ep0ud.cloudfront.net/memu.pro/static/memu-logo.png" />
        <meta property="og:image:alt" content="MemU Agent Memory Platform" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Agent Memory System | MemU - Agentic Memory for AI" />
        <meta name="twitter:description" content="Agent memory platform for LLM applications. Autonomous memory management with higher accuracy, faster retrieval, and lower cost." />
        <meta name="twitter:image" content="https://d192tm8h0ep0ud.cloudfront.net/memu.pro/static/memu-logo.png" />
        <meta name="twitter:image:alt" content="MemU Agent Memory Platform" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "MemU",
            "description": "An advanced agentic memory layer for LLM applications, featuring autonomous agents that intelligently manage, organize, and evolve AI memory systems for higher accuracy, faster retrieval, and lower cost.",
            "url": "https://memu.pro",
            "logo": "https://d192tm8h0ep0ud.cloudfront.net/memu.pro/static/logo.png",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Cross-platform",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "author": {
              "@type": "Organization",
              "name": "MemU Team"
            },
            "keywords": ["agentic memory", "autonomous agents", "AI memory systems", "memory management", "artificial intelligence", "LLM applications", "agentic architecture", "autonomous memory management", "intelligent memory", "AI agents", "memory evolution", "self-organizing memory", "framework", "open-source"]
          })}
        </script>
      </Helmet>
      
      <main>
        <Hero />
        <Features />
        {/* <Clients /> */}
        {/* <Testimonials /> */}
        <Developers />
        <Platform />
        <Enterprise />
        <Benchmark />
        <Domain />
        <Blog />
        <FAQ />
        <Community />
        <CTA />
      </main>
    </>
  );
};

export default Home;